import React from "react";
import "./Logo.sass";

export function Logo(rest) {
  return (
    <img {...rest} src="https://storage.googleapis.com/orkestro-prd/images/logo/logo-eduk-2025.svg" className="Logo" />
  );
}
